"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createSuggestedActionsStyle;
/* eslint no-empty-pattern: "off" */

/* eslint no-magic-numbers: ["error", { "ignore": [2] }] */

function createSuggestedActionsStyle(_ref) {
  var paddingRegular = _ref.paddingRegular,
      suggestedActionLayout = _ref.suggestedActionLayout;

  if (suggestedActionLayout === 'stacked') {
    return {
      paddingBottom: paddingRegular / 2,
      paddingLeft: paddingRegular / 2,
      paddingRight: paddingRegular / 2,
      paddingTop: paddingRegular / 2
    };
  }

  return {
    paddingBottom: paddingRegular / 2,
    paddingTop: paddingRegular / 2
  };
}